import React, { useEffect, useState, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import PendingOrdersForm from '../../components/forms/PendingOrdersForm'
import axiosInstance from '../../api/axiosInstance'

interface OrderDetail {
  id: number
  orders_id: number
  origin_order_id: number
  store_name: string
  status: string
  total: string
  envio?: string
  guia?: string
  date_created: string
  date_modified: string
  agente?: number
  customer: {
    first_name: string
    last_name: string
    email: string
    document?: string
    tipo_documento?: string
    tipo_persona?: string
  }
  billingAddress: {
    address_1: string
    city: string
    state: string
    country: string
    postcode: string
    phone?: string
  }
  shippingAddress: {
    address_1: string
    city: string
    state: string
    country: string
    postcode: string
    phone?: string
  }
  lineItems: Array<{
    product_id: string
    product_name: string
    quantity: number
    price: string
  }>
  extraDetails?: Record<string, unknown>
}

/**
 * Cotizar envío: formulario directo (sin lista lateral).
 * Si la URL trae /envios/liquidar/:id, carga ese pedido.
 */
const LiquidateShipping: React.FC = () => {
  const location = useLocation()
  const idParam = useMemo(() => {
    const tail = location.pathname.replace(/^\/envios\/liquidar\/?/, '')
    return /^\d+$/.test(tail) ? tail : null
  }, [location.pathname])

  const [selectedOrder, setSelectedOrder] = useState<OrderDetail | null>(null)
  const [isLoadingOrderDetails, setIsLoadingOrderDetails] = useState(false)

  useEffect(() => {
    if (!idParam) {
      setSelectedOrder(null)
      return
    }

    const loadOrder = async () => {
      try {
        setIsLoadingOrderDetails(true)
        const response = await axiosInstance.get(`/list/${idParam}`)
        setSelectedOrder(response.data)
      } catch (error) {
        console.error('Error fetching order details:', error)
        setSelectedOrder(null)
      } finally {
        setIsLoadingOrderDetails(false)
      }
    }

    void loadOrder()
  }, [idParam])

  return (
    <div className="h-full">
      <div
        className="overflow-y-auto p-6"
        style={{ maxHeight: 'calc(100vh - 64px)' }}
      >
        {isLoadingOrderDetails ? (
          <div className="flex flex-col items-center justify-center h-full">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-800 mb-4" />
            <p className="text-gray-600 text-lg font-medium">Cargando detalles del pedido...</p>
            <p className="text-gray-500 text-sm mt-2">Obteniendo información completa del pedido</p>
          </div>
        ) : (
          <PendingOrdersForm
            isLiquidateMode
            orderDetail={selectedOrder}
            hideDestinationFields={['nombre', 'empresa', 'email', 'celular', 'referencia', 'nit']}
            hidePackageFields={['contenido', 'valor_recaudar', 'transportadora']}
            hideProductSection
          />
        )}
      </div>
    </div>
  )
}

export default LiquidateShipping
